import * as React from 'react'
import { styled } from 'styled-components'
import { Modal } from 'react-bootstrap'
import * as domain from '@packages/domain'
import { Image } from './Image'

const DetailTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  color: #0d3c61;

  margin-bottom: 0;
`

const DetailImageContainer = styled.div`
  margin: 0 auto 1rem auto;
  width: 100%;
  max-width: 500px;
  height: auto;
`

const DetailDescription = styled.div`
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
`

const ModalHeader = styled(Modal.Header)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  margin-top: 0.75rem;
`

const InfoCircle = styled.div`
  align-self: flex-end;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--bs-secondary);
  color: var(--bs-secondary);
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
  z-index: 1;
  aspect-ratio: 1;

  @media screen and (min-width: 768px) {
    border-width: 2px;
  }
`

export interface OptionDetailProps {
  option: domain.Option.Type
  show: boolean
  onClose: () => void
}

export const OptionDetail: React.FC<OptionDetailProps> = ({ option, show, onClose }) => {
  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <ModalHeader closeButton>
        <InfoCircle>i</InfoCircle>
        <DetailTitle>{option.name}</DetailTitle>
      </ModalHeader>
      <Modal.Body>
        <DetailImageContainer>
          <Image imageId={option.image} alt={option.name} size="full" />
        </DetailImageContainer>
        <DetailDescription>{option.description}</DetailDescription>
      </Modal.Body>
    </Modal>
  )
}
